var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingBottomlines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1280,
    height: 218,
    viewBox: "0 0 1280 218",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1292.92 204.425C1292.92 204.425 1293.46 203.472 1294 203.472C1186.05 138.166 1031.14 76.6736 864.898 71.9067C698.655 63.8031 530.793 110.995 387.759 174.394C246.344 237.317 129.758 316.923 35.8418 358.395C-58.6146 401.773 -142.276 407.494 -220 361.732C-219.46 362.208 -218.921 363.162 -217.841 364.115C-140.117 410.83 -56.4556 405.587 37.4611 362.208C130.838 320.737 246.884 241.13 388.299 177.731C531.333 113.855 698.655 66.6632 864.898 74.2902C1030.6 78.5803 1185.51 139.596 1293.46 204.425H1292.92Z",
    fill: "#149C84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-233.036 157.561C-233.036 157.561 -233.518 156.868 -234 156.522C-117.879 72.669 33.4156 15.15 190.01 3.369C347.569 -10.491 504.164 20.001 645.34 65.739C784.107 111.13 905.046 173.847 999.967 215.427C1096.33 258.393 1175.35 279.183 1251 270.52C1250.52 270.867 1250.04 271.56 1249.55 271.906C1173.91 280.915 1094.89 260.472 999.003 217.852C904.564 176.272 783.625 113.556 645.34 67.818C504.645 22.08 348.051 -8.412 190.492 5.10149C33.4156 16.8825 -117.397 73.7085 -233.036 157.215V157.561Z",
    fill: "#149C84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingBottomlines);
export default __webpack_public_path__ + "static/media/landingBottomlines.607190622e4447a63985c4a4e3729d6e.svg";
export { ForwardRef as ReactComponent };